import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import "./MultiSelectChip.css";

export default function MultiSelectChip({ options = [], label, onChange, name, value }) {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      setSelected([]);
    } else if (Array.isArray(value)) {
      setSelected(value);
    }
  }, [value]);

  const handleChange = (_event, newValue) => {
    setSelected(newValue);
    onChange({ target: { name, value: newValue } });
  };

  return (
    <Autocomplete
      className="multi-select-chip"
      multiple
      disableCloseOnSelect
      filterSelectedOptions
      options={options}
      value={selected}
      onChange={handleChange}
      size="small"
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            key={`${option}-${index}`}
            label={option}
            size="small"
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label={label} size="small" />
      )}
    />
  );
}
